var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CardBase",
        [
          _c(
            "MacroSubHeader",
            { attrs: { title: "Consultas SPC", icon: "el-icon-notebook-2" } },
            [
              _c(
                "template",
                { slot: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.openModal }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _vm._v(
                        "\n                    Nova Consulta\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between px-3 mt-3",
              style: { gap: "20px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex align-items-center",
                  style: { gap: "8px", width: "375px" }
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["##.###.###/####-##", "###.###.###-##"],
                        expression: "['##.###.###/####-##', '###.###.###-##']"
                      }
                    ],
                    style: { maxWidth: "375px" },
                    attrs: {
                      size: "small",
                      placeholder: "Buscar por CPF/CNPJ",
                      "prefix-icon": "el-icon-search",
                      clearable: ""
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.setFilters()
                      }
                    },
                    model: {
                      value: _vm.filters.search,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "search", $$v)
                      },
                      expression: "filters.search"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary", circle: "" },
                      on: {
                        click: function($event) {
                          return _vm.setFilters()
                        }
                      }
                    },
                    [_c("i", { staticClass: "el-icon-search" })]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "el-dropdown",
                    {
                      attrs: { size: "mini", "split-button": "", plain: "" },
                      on: { command: _vm.handleSetOrder }
                    },
                    [
                      _c("strong", [_vm._v("Ordernar")]),
                      _vm._v(
                        ": " +
                          _vm._s(
                            _vm.filters.orderBy == "latest"
                              ? "Recentes"
                              : "Antigos"
                          ) +
                          "\n                    "
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "latest" } },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("i", { staticClass: "el-icon-top mr-2" }),
                                  _vm._v(
                                    "\n                                Mais Recentes\n                            "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "oldest" } },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-bottom mr-2"
                                  }),
                                  _vm._v(
                                    "\n                                Mais Antigos\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("CardBase", [_c("SPCList", { ref: "SPCListView" })], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c("SPCCreateModal", {
        ref: "SPCCreateModal",
        on: { created: _vm.handleDispatch }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f12e9a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f12e9a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_spc/Index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6f12e9a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_spc/Index.vue
// module chunks = 2